import React from 'react'
import { Trans } from '@lingui/macro'

import { linkBuilder, staticLinks } from '../../../../shared/linkBuilder'
import { navigateTo } from '../../app/util/appHistory'
import { LinkBox } from 'front-end/src/components'

export const AccountDropdown = () => {
  return (
    <div className="MainHeader__account__list">
      <div className="DropdownLabel">
        <Trans>User management</Trans>
      </div>
      <LinkBox
        className="DropdownLink"
        onClick={() => navigateTo(linkBuilder.groups())}
      >
        <i className="icon icon-people" /> <Trans>Groups</Trans>
      </LinkBox>
      <LinkBox
        className="DropdownLink"
        onClick={() => navigateTo(linkBuilder.users())}
      >
        <i className="icon icon-user-female" /> <Trans>People</Trans>
      </LinkBox>

      <LinkBox
        className="DropdownLink"
        onClick={() => navigateTo(staticLinks.emailBlocklist)}
      >
        <i className="icon icon-envelope" /> <Trans>Email blocklist</Trans>
      </LinkBox>

      <div className="DropdownDivider" />
      <div className="DropdownLabel">
        <Trans>Account settings</Trans>
      </div>

      <LinkBox
        className="DropdownLink"
        onClick={() => navigateTo(staticLinks.accountSettings)}
      >
        <i className="icon icon-magic-wand" /> <Trans>Customise</Trans>
      </LinkBox>
      <LinkBox
        className="DropdownLink"
        onClick={() => navigateTo(staticLinks.accountAuthenticationOptions)}
      >
        <i className="icon icon-key" /> <Trans>Authentication</Trans>
      </LinkBox>
      <LinkBox
        className="DropdownLink"
        onClick={() => navigateTo(staticLinks.accountNotifications)}
      >
        <i className="icon icon-envelope" /> <Trans>Notifications</Trans>
      </LinkBox>
    </div>
  )
}
